export default __webpack_public_path__ + "static/media/contact.42b5dfc2.png";